import { compose, composeU } from '@bem-react/core';
import {
    Spin as SpinPresenter,
    withPositionCenter,
    withSizeL,
    withSizeM,
    withViewDefault
} from '@yandex-lego/components/Spin/desktop';

const Spin = compose(
    withViewDefault,
    composeU(withSizeL, withSizeM),
    withPositionCenter
)(SpinPresenter);

export default Spin;
